














import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class LinkBreakIcon extends Vue {
	@Prop({ default: '#865946' })
	public color!: string;
}
